// extracted by mini-css-extract-plugin
export default {"dashbordTitleContainer":"feedback_dashbordTitleContainer__-FtHo"};